<template>
    <v-autocomplete v-model="addressees" multiple v-bind="{ ...$attrs, items, itemText }" item-value="_application" :menuProps="{ attach: `.texting-form-addresses-${className}` }" :class="`texting-form-addresses-${className}`" return-object small-chips @input="emit" />
</template>

<script>
export default {
    props: {
        value: { type: Array, default: () => [] },
        items: { type: Array, default: () => [] },
    },
    data: () => ({
        addressees: [],

        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.addressees = [...this.value];
        },
        emit() {
            this.$emit("input", this.addressees);
        },
        itemText({ name, phone }) {
            return `${name} / ${phone}`;
        },
    },
};
</script>

<style></style>
